// extracted by mini-css-extract-plugin
export default {"container":"cha_2R1cQ","derek":"cha_der_mr783","bubble":"cha_bub_SbKBm","character":"cha_cha_uLDvn","roxanne":"cha_rox_1QklB","animRoot":"cha_ani_brk5t","slow-float":"cha_slo_a-TIl"};